<template lang="pug">
.c-base-tag-homeland
  b-taglist(:style="{ fontWeight: 'bold' }"
    attached)
    b-tag(type="is-dark"
      size="is-small") 故鄉
    b-tag(type="is-info"
      size="is-small")
      slot {{ value }}
</template>

<script>
export default {
  name: "BaseTagHomeland",
  props: {
    value: {
      type: String,
      default: ""
    }
  }
};
</script>
